import { Controller } from "@hotwired/stimulus"
import { Avatar } from "@dicebear/core"
import { AVATAR_STYLE, AVATAR_OPTIONS } from "../../lib/avatar_options"
import { captureAvatarPng, blobToDataUrl } from "../../lib/avatar_capture"

export default class extends Controller {
  static targets = ["preview", "input", "capture"]
  static values = { seed: String, size: Number }

  connect() {
    this.render(this.seedValue)
  }

  randomize() {
    const seed = crypto.randomUUID().slice(0, 13)
    this.inputTarget.value = seed
    this.render(seed)
  }

  preview() {
    this.render(this.inputTarget.value.trim() || this.seedValue)
  }

  render(seed) {
    this.previewTarget.innerHTML = new Avatar(AVATAR_STYLE, {
      ...AVATAR_OPTIONS,
      seed,
      size: this.sizeValue || 96
    }).toString()
  }

  async queueCapture() {
    if (!this.hasCaptureTarget) return

    try {
      const seed = this.inputTarget.value.trim() || this.seedValue
      const blob = await captureAvatarPng(seed)
      this.captureTarget.value = await blobToDataUrl(blob)
    } catch {}
  }
}
